import { createTheme } from '@mui/material/styles';
import { useEffect } from 'react';
import {
  BLACK,
  BLUE,
  DARK_BLACK,
  GRAY,
  GREEN,
  LIGHT_GRAY,
  ORANGE,
  RED,
  WHITE,
} from '../types/core/color.types';
import { STORAGE_KEYS } from '../utils/core/localStorageKeys';
import { useLocalStorage } from './useLocalStorage';
export enum ThemeType {
  LIGHT = 'light',
  DARK = 'dark',
}

/**
 * default theme definition
 */
export const defaultTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: ORANGE,
      contrastText: WHITE,
    },
    secondary: {
      main: GRAY,
      contrastText: WHITE,
    },
    info: {
      main: BLUE,
      contrastText: BLACK,
    },
    success: {
      main: GREEN,
      contrastText: WHITE,
    },
    error: {
      main: RED,
      contrastText: WHITE,
    },
  },
});

/**
 * dark theme definition
 */
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    text: {
      primary: LIGHT_GRAY,
    },
    primary: {
      main: ORANGE,
      contrastText: LIGHT_GRAY,
    },
    secondary: {
      main: GRAY,
      contrastText: DARK_BLACK,
    },
    info: {
      main: BLUE,
      contrastText: LIGHT_GRAY,
    },
    success: {
      main: GREEN,
      contrastText: LIGHT_GRAY,
    },
    error: {
      main: RED,
      contrastText: LIGHT_GRAY,
    },
  },
});

/**
 * Hook to use and switch between themes
 */
export function useLocalTheme() {
  const [localTheme, setLocalTheme] = useLocalStorage(
    STORAGE_KEYS.THEME,
    location.search === '?dark=true' ? ThemeType.DARK : ThemeType.LIGHT,
  );

  useEffect(() => {
    if (location.search.includes('?dark=false') && localTheme === ThemeType.DARK) {
      setLocalTheme(ThemeType.LIGHT);
      window.location.search = `dark=false`;
    }
    if (location.search.includes('?dark=true') && localTheme === ThemeType.LIGHT) {
      setLocalTheme(ThemeType.DARK);
      window.location.search = `dark=true`;
    }
  }, [location.search]);

  const changeLocalTheme = () => {
    let theme = localTheme;
    let urlQuery = location.search;
    if (localTheme === ThemeType.LIGHT) {
      theme = ThemeType.DARK;
      urlQuery = `dark=true`;
    }
    if (localTheme === ThemeType.DARK) {
      theme = ThemeType.LIGHT;
      urlQuery = `dark=false`;
    }
    setLocalTheme(theme);
    window.location.search = urlQuery;
  };

  return {
    changeLocalTheme,
    localTheme,
  };
}
